import React, { useCallback } from 'react';

import { Title } from '@mantine/core';
import Drawer from 'components/Drawer';
import { ProgramRetrieve } from 'types';

import EditProgramForm from '../EditProgramForm';

interface IEditProgramDrawerProps {
  opened: boolean;
  closeHandler: () => void;
  program?: ProgramRetrieve;
  permission?: boolean;
}

const EditProgramDrawer = ({
  opened,
  closeHandler,
  program,
  permission = true,
}: IEditProgramDrawerProps): JSX.Element => {
  const handleClose = useCallback(() => {
    closeHandler();
  }, [closeHandler]);

  return (
    <Drawer
      opened={opened}
      onClose={handleClose}
      size={600}
      title={<Title order={3}> {program?.kiloClassType.name}</Title>}
      closeOnClickOutside
    >
      <EditProgramForm program={program} permission={permission} handleClose={handleClose} />
    </Drawer>
  );
};

export default EditProgramDrawer;
